module.exports = __webpack_public_path__ + "static/media/bg.c54d05a4.jpg";